export default {
  // App Config
  SET_APP_CONFIG: 'SET_APP_CONFIG',
  SET_APP_CONSENT: 'SET_APP_CONSENT',

  // Navigation
  SET_RETURN_ROUTE: 'SET_RETURN_ROUTE',
  SET_SCOPE: 'SET_SCOPE',
  SET_FILTER_DATA: 'SET_FILTER_DATA',
  CLEAR_FILTER_DATA: 'CLEAR_FILTER_DATA',

  // Page
  SET_PAGE_NAVIGATION_ROUTE_TITLE: 'SET_PAGE_NAVIGATION_ROUTE_TITLE',
  SET_ROUTE_TITLE: 'SET_ROUTE_TITLE',

  // App loader
  SET_APP_PENDING: 'SET_APP_PENDING',
  SET_APP_BAR_IS_HIDDEN: 'SET_APP_BAR_IS_HIDDEN',

  // Logout State
  SET_LOGOUT_STATE: 'SET_LOGOUT_STATE',

  // Current logout time
  SET_CURRENT_LOGOUT_TIME: 'SET_CURRENT_LOGOUT_TIME',

  // Overlay
  SET_OVERLAY_VISIBILITY: 'SET_OVERLAY_VISIBILITY',

  // Basket
  SET_BASKET_VISIBILITY: 'SET_BASKET_VISIBILITY',

  // Navigation
  SET_NAVIGATION_DRAWER_VISIBILITY: 'SET_NAVIGATION_DRAWER_VISIBILITY',

  // Add portal targets to state
  ADD_PORTAL_TARGET: 'ADD_PORTAL_TARGET',

  // Search
  // SET_SEARCH_DIALOG_VISIBILITY: 'SET_SEARCH_DIALOG_VISIBILITY',
  // SET_SEARCH_QUERY: 'SET_SEARCH_QUERY',
  // SET_SEARCH_SELECTION: 'SET_SEARCH_SELECTION',
  // SET_SEARCH_PAGE: 'SET_SEARCH_PAGE', // ToDo: Remove
  // SET_SEARCH_URL: 'SET_SEARCH_URL', // ToDo: Remove
  // SET_SEARCH_QUERY_MIN_LENGTH: 'SET_SEARCH_QUERY_MIN_LENGTH', // ToDo: Remove
  SET_SEARCH_IMMEDIATE: 'SET_SEARCH_IMMEDIATE',
  // SET_SEARCH_IS_OVERVIEW: 'SET_SEARCH_IS_OVERVIEW', // ToDo: Remove
  // SET_SEARCH_PARAMS: 'SET_SEARCH_PARAMS',
  // SET_SEARCH_SKU: 'SET_SEARCH_SKU',
  // ADD_CATEGORY: 'ADD_CATEGORY',

  // Product List
  SET_PRODUCT_VIEW: 'SET_PRODUCT_VIEW',

  // Dimension
  SET_DIMENSIONS: 'SET_DIMENSIONS',
  SET_SHOW_SCROLL_TO_TOP: 'SET_SHOW_SCROLL_TO_TOP',

  // Language
  SET_LOCALE: 'SET_LOCALE',

  // My account

  // Help
  SET_HELP_PATH: 'SET_HELP_PATH',

  // Help return value
  SET_RETURN_FROM_HELP: 'SET_RETURN_FROM_HELP',

  // Notifications
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION_BY_ID: 'REMOVE_NOTIFICATION_BY_ID',
  // NOTIFICATION_MESSAGE: 'NOTIFICATION_MESSAGE',
  // OPEN_NOTIFICATION_MESSAGE: 'OPEN_NOTIFICATION_MESSAGE',
  // NOTIFICATION_MESSAGE_TYPE: 'NOTIFICATION_MESSAGE_TYPE',
  SET_NEWS_UNREAD: 'SET_NEWS_UNREAD',

  ADD_PAYMENT_TERMS: 'ADD_PAYMENT_TERMS',

  SET_SELECTED_BRAND: 'SET_SELECTED_BRAND',
}
